module.exports = __webpack_public_path__ + "static/media/EB7.1e569624.jpg";